export const ReportingProviderTypes = {
  PowerBI: 1,
}
